import {
  normalizeCategoryLabel,
  type CanonicalCategoryKey,
} from "./categoryNormalization";

/**
 * Stable per-canonical-key colors for category mode (Today/Habits).
 * Composite Screen Time labels (e.g. "Productivity & Finance") resolve to their
 * canonical key via normalizeCategoryLabel and inherit that key's color/icon.
 */
export const CATEGORY_COLORS: Record<CanonicalCategoryKey, string> = {
  books: "#7a9eb8",
  business: "#9a8878",
  catalogs: "#8898a8",
  developerTools: "#6b9080",
  education: "#8a9a72",
  entertainment: "#c28f65",
  finance: "#7ab0b8",
  foodAndDrink: "#b8886a",
  games: "#9a7ab8",
  graphicsAndDesign: "#c27a9a",
  healthAndFitness: "#72a892",
  kids: "#d4a574",
  lifestyle: "#a892c2",
  medical: "#be7777",
  miscellaneous: "#8b8b80",
  music: "#7ab89a",
  navigation: "#6a98b8",
  news: "#8890a8",
  newsstand: "#7888a0",
  photoAndVideo: "#a88098",
  productivity: "#8fa7c2",
  reference: "#809878",
  shopping: "#b8a07a",
  socialNetworking: "#9a8bc2",
  sports: "#78a878",
  stickers: "#c2a878",
  travel: "#72a8b8",
  system: "#a89878",
  utilities: "#7b837e",
  weather: "#88b8c8",
  uncategorized: "#7a8a7a",
  other: "#6a7a72",
  website: "#6898a8",
};

const FALLBACK_COLOR = CATEGORY_COLORS.other;

export function resolveCategoryColor(labelOrBucket: string): string {
  const key = normalizeCategoryLabel(labelOrBucket);
  if (key) return CATEGORY_COLORS[key];
  return FALLBACK_COLOR;
}

export function assignCategoryEntityColors<
  T extends { displayName: string; category?: string; isCategory: boolean; color?: string | null },
>(entities: T[]): T[] {
  return entities.map((entity) =>
    entity.isCategory
      ? { ...entity, color: resolveCategoryColor(entity.category ?? entity.displayName) }
      : entity,
  );
}
